export enum EwSocket {
  Namespace = '/api.enterwait.com/api',
}
